function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from 'react';

/**
 * Debounces a value.
 * Returns the initial value immediately.
 * Returns the latest value after no changes have occurred for the debounce duration.
 * @param value Value to debounce
 * @param debounceMs Amount of time to debounce
 * @returns The debounced value + whether the value is still debouncing
 */
export function useDebouncedValue(value, debounceMs) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDebouncing = _useState2[0],
    setIsDebouncing = _useState2[1];
  var _useState3 = useState(value),
    _useState4 = _slicedToArray(_useState3, 2),
    debouncedValue = _useState4[0],
    setDebouncedValue = _useState4[1];

  // Keep `isDebouncing` in sync with `value` and `debounceMs` by setting state
  // during render instead of in `useEffect`
  // https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
  var _useState5 = useState(value),
    _useState6 = _slicedToArray(_useState5, 2),
    previousValue = _useState6[0],
    setPreviousValue = _useState6[1];
  var _useState7 = useState(debounceMs),
    _useState8 = _slicedToArray(_useState7, 2),
    previousDebounceMs = _useState8[0],
    setPreviousDebounceMs = _useState8[1];
  if (value !== previousValue || debounceMs !== previousDebounceMs) {
    setIsDebouncing(true);
    setPreviousValue(value);
    setPreviousDebounceMs(debounceMs);
  }
  useEffect(() => {
    var isCancelled = false;
    var timeoutId = setTimeout(() => {
      if (!isCancelled) {
        setIsDebouncing(false);
        setDebouncedValue(value);
      }
    }, debounceMs);
    return () => {
      isCancelled = true;
      clearTimeout(timeoutId);
    };
  }, [value, debounceMs]);
  return {
    isDebouncing,
    value: debouncedValue
  };
}
export default useDebouncedValue;
//# sourceMappingURL=useDebouncedValue.js.map